module.exports = __webpack_public_path__ + "static/media/allartisans.bd7bdd47.jpg";